import type { IconType } from "@/react/components/shared/Icon";
import { Icon } from "@/react/components/shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";

interface ActionButtonProps {
  iconName: IconType;
  onClick: () => void;
  text: string;
}

export const ActionButton = ({
  iconName,
  text,
  onClick,
}: ActionButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    className="hover:bg-secondary border-primary bg-primary text-dark shadow-xs hover:border-dark flex items-center gap-1 rounded-2xl border px-3 py-[10px] focus:outline-none"
  >
    <div className="flex items-center justify-center px-[2px] py-1">
      <Icon
        type={iconName}
        className="text-grey-900 dark:text-grey-50"
        size={16}
      />
    </div>
    <Typography.BodySm color="text-secondary" weight="font-medium">
      {text}
    </Typography.BodySm>
  </button>
);
